import React, { useContext, useEffect, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom'

import DataContext from '../../contexts/data.jsx'

import Payment from './Payment.jsx'

const PaymentsStep = ({ setData }) => {
    let defaultPayment = null,
    paymentsShowsIDs = []

    const data = useContext(DataContext),
    handleChangePayment = (payment) => {
        const newContextData = Object.assign({}, data)

        newContextData.payments.id = parseInt(payment.ID) || null

        setData(newContextData)
    },
    checkRestriction = (payment) => {
        const paymentRestriction = data.data.restrictions.PAYMENTS[payment.ID]

        if (payment.ACTIVE && paymentRestriction) {
            /*
            //Locations
            if (
                deliveryRestriction.LOCATIONS && 
                deliveryRestriction.LOCATIONS.length > 0
            ) {
                if (deliveryRestriction.LOCATIONS.indexOf(data.data.current_location && data.data.current_location.ID) === -1) {
                    return false
                }
            }

            //Exclude locations
            if (
                deliveryRestriction.EXCLUDE_LOCATIONS && 
                deliveryRestriction.EXCLUDE_LOCATIONS.length > 0
            ) {
                if (deliveryRestriction.EXCLUDE_LOCATIONS.indexOf(data.data.current_location && data.data.current_location.ID) !== -1) {
                    return false
                }
            }
            */
            
            if (payment.CODE === 'CASH' && data.delivery.store_id === data.data.CASH_STORE_ID) {
                return false
            }

            if (payment.CODE === 'DOLYAME' && (data.data?.cart_info?.summary < 3000 || data.data?.cart_info?.summary >= 30000)) {
                return false
            }
            
            //Persons
            if (
                paymentRestriction.PERSONS && 
                paymentRestriction.PERSONS.length > 0
            ) {
                if (paymentRestriction.PERSONS.indexOf(data.contacts.person) === -1) {
                    return false
                }
            }

            //Delivery
            if (
                paymentRestriction.DELIVERY && 
                paymentRestriction.DELIVERY.length > 0
            ) {
                if (paymentRestriction.DELIVERY.indexOf(data.delivery.id) === -1) {
                    return false
                }
            }
        }

        if (!defaultPayment) {
            defaultPayment = payment
        }

        paymentsShowsIDs.push(payment.ID)

        return true
    }

    useEffect(() => {
        if (!data.payments.id && defaultPayment) {
            handleChangePayment(defaultPayment)
        }
    }, [])

    useLayoutEffect(() => {
        if (paymentsShowsIDs.length > 0) {
            if (data.payments.id > 0) {
                if (paymentsShowsIDs.indexOf(data.payments.id) === -1) {
                    handleChangePayment(data.data._payments[paymentsShowsIDs[0]])
                }
            } else if (data.data._payments[paymentsShowsIDs[0]]) {
                handleChangePayment(data.data._payments[paymentsShowsIDs[0]])
            }
        }
    })

    return <div className="happy-order__step happy-order__step_payments">
        <div className="happy-order__step-header">
            <h2 className="happy-order__step-title">Шаг 3. Способ оплаты</h2>

            <div className="happy-order__step-notice">
                Выберите удобный способ оплаты заказа
            </div>
        </div>

        <div className="happy-order__payments">
            <div className="happy-order__payments-list">
                { data.data.payments.map((payment) => {
                    return checkRestriction(payment) ? <Payment
                        key={ `payment-${ payment.ID }` }
                        payment={ payment }
                        data={ data }
                        handleChangePayment={ handleChangePayment }
                    /> : null
                }) }
            </div>
            <div className="happy-order__payments-info">
                { data.data.payments.map((payment) => {
                    return (data.payments.id === payment.ID) ? <div
                        key={ `payment-text-${ payment.ID }` }
                        className="happy-order__payments-content"
                    >
                        <h2 className="happy-order__payments-title">{ payment.NAME }</h2>

                        <p className="happy-order__payments-text" dangerouslySetInnerHTML={ { __html : payment.DESCRIPTION } } />
                    </div> : null
                }) }
            </div>
        </div>
    </div>
}

export default PaymentsStep